import { useState, useCallback } from 'react'

export default <T>(initialState: T): [T, (newState: Partial<T>) => void] => {
  const [state, setState] = useState<T>(initialState)
  const updateState = useCallback((newState: Partial<T>) => setState(old => ({ ...old, ...newState })), [])
  return [state, updateState]
}
